import React, { createRef } from 'react';
import { createPortal } from 'react-dom';
import throttle from 'lodash/throttle';

import { getOffsetTop, getScrollTop } from './WithScrollingView';

/**
 * @deprecated Use the useStickElementOnScroll hook instead. Example is available at FilterNav
 */

const getDisplayName = (WrappedComponent) => WrappedComponent.displayName || WrappedComponent.name || 'Component';

export default function withHeaderPortal(WrappedComponent) {
  class WithHeaderPortal extends WrappedComponent {
    state = {
      ...(this.state || {}),
      portalActive: false,
    };

    constructor(props) {
      super(props);

      this.anchorRef = createRef();
      this.getAnchorElement = this.getAnchorElement.bind(this);
      this.onScroll = throttle(this.onScroll.bind(this), 100);
    }

    getAnchorElement() {
      return this.anchorRef?.current;
    }

    onScroll() {
      const {
        portalActive: prevPortalActive,
      } = this.state;
      const anchor = this.getAnchorElement();
      const scrollTop = getScrollTop();
      if (!anchor || typeof scrollTop !== 'number') {
        return null;
      }
      const offsetTop = getOffsetTop(anchor);
      const headerHeight = document.querySelector('.header-nav')?.offsetHeight || 0;
      const portalActive = scrollTop + headerHeight > offsetTop;
      if (prevPortalActive !== portalActive) {
        this.setState({ portalActive });
      }
      return portalActive;
    }

    componentDidMount(args) {
      this.onScroll();
      if (document?.addEventListener) {
        document.addEventListener('scroll', this.onScroll);
      }
      if (super.componentDidMount) {
        super.componentDidMount.apply(this, args);
      }
    }

    componentWillUnmount() {
      if (document?.removeEventListener) {
        document.removeEventListener('scroll', this.onScroll);
      }
      if (this.componentWillUnmountCallback) {
        this.componentWillUnmountCallback();
      }

      if (super.componentWillUnmount) {
        super.componentWillUnmount.apply(this);
      }
    }

    render() {
      const {
        portalActive,
      } = this.state;
      const portal = typeof document !== 'undefined'
        ? document?.querySelector?.('.header-navigation-portal')
          || document?.querySelector?.('.header-nav__portal')
        : null;

      return (
        <div>
          <div ref={this.anchorRef} />
          {super.render()}
          {portalActive && portal && (
            createPortal(super.render(), portal)
          )}
        </div>
      );
    }
  }

  WithHeaderPortal.displayName = getDisplayName(WrappedComponent);

  return WithHeaderPortal;
}
